export const API_CODES = {
  SUCCESS: 200,
  CREATED: 201,

  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,

  UNPROCESSABLE_CONTENT: 422,

  MAINTENANCE: 503
};

export const FORBIDDEN_CODES = {
  UNVERIFIED: 498,
  ROLE_ACCESS: 499
};

export const SERVICE_ENDPOINTS = {
  DASHBOARD: "dashboard",
  INTERNATIONAL_TRANSFER: "international_transfer"
};

export const ACTION_ENDPOINTS = {
  // dashboard
  GET_DASHBOARD_PENDING_TRANSACTION: "get_dashboard_pending_transaction",

  // international_transfer
  ITR_GET_BANKS: "itr_get_banks",
  ITR_GET_COUNTRIES: "itr_get_countries",
  ITR_GET_EXCHANGE_RATES: "itr_get_exchange_rates",
  ITR_GET_INACTIVE_EXCHANGE_RATES: "itr_get_inactive_exchange_rates",
  ITR_CREATE_QUOTATION: "itr_create_quotation",
  ITR_VALIDATE_SPECIAL_IDENTIFIER: "itr_validate_special_identifier",
  ITR_GET_FORM_DATA: "itr_get_form_data",
  ITR_SUBMIT_BUNDLE_DRAFT: "itr_submit_bundle_draft",
  ITR_UPDATE_BUNDLE_DRAFT: "itr_update_bundle_draft",
  ITR_GET_BUNDLE_DRAFT: "itr_get_bundle_draft",
  ITR_CHECK_PROCESS_PROGRESS: "itr_check_process_progress",
  ITR_GET_BUNDLE_DRAFT_SUMMARY: "itr_get_bundle_draft_summary",
  ITR_CREATE_BUNDLE_TRANSACTION: "itr_create_bundle_transaction",
  ITR_REQUEST_DEPOSIT_OTP: "itr_request_deposit_otp",
  ITR_PROCESS_BUNDLE_DRAFT: "itr_process_bundle_draft",
  ITR_GET_TRANSACTION_LIST: "itr_get_transaction_list",
  ITR_GET_BUNDLE_LIST: "itr_get_bundle_list",
  ITR_UPLOAD_FILE: "itr_upload_file",
  ITR_DELETE_NOTIFICATION_KEY: "itr_delete_notification_key",
  ITR_GET_BUNDLE_BY_ID: "itr_get_bundle_by_id",
  ITR_GET_BUNDLE_SUMMARY: "itr_get_bundle_summary",
  ITR_CANCEL_BUNDLE_TRANSACTION: "itr_cancel_bundle_transaction",
  ITR_CONFIRM_BUNDLE_TRANSACTION: "itr_confirm_bundle_transaction",
  ITR_GET_TRANSACTION_BY_ID: "itr_get_transaction_by_id",
  ITR_CHECK_EDD_PROCESS: "itr_check_edd_process",
  ITR_DELETE_ALL_DRAFT_REVIEW: "itr_delete_all_draft_review",
  ITR_DELETE_DRAFT_REVIEW: "itr_delete_draft_review",
  ITR_GENERATE_RECEIPT: "itr_generate_receipt",
  ITR_GENERATE_REPORT: "itr_generate_report",
  ITR_GET_REPORT: "itr_get_report",
  ITR_UPLOAD_CREDIT_RECEIPT: "itr_upload_credit_receipt"
};

export const ONBOARDING_MIGRATION_FLAGS = {
  IS_NEW_AUTHENTICATION: "isNewAuthentication",
  IS_NEW_REGISTRATION: "isNewRegistration",
  IS_NEW_VERIFICATION: "isNewVerification",
  IS_NEW_RESET_PASSWORD: "isNewResetPassword",
  IS_NEW_GENERAL: "isNewGeneral",
  IS_NEW_SETTING: "isNewSetting",
  IS_NEW_API_INFO: "isNewApiInfo",
  IS_NEW_MODULE_ACCESS_OTP: "isNewModuleAccessOtp",
  IS_NEW_USER_MANAGEMENT: "isNewUserManagement"
};

export const ENDPOINTS_PLATFORM_WHITELIST_FLAG = {
  [ONBOARDING_MIGRATION_FLAGS.IS_NEW_AUTHENTICATION]: false,
  [ONBOARDING_MIGRATION_FLAGS.IS_NEW_REGISTRATION]: false,
  [ONBOARDING_MIGRATION_FLAGS.IS_NEW_VERIFICATION]: false,
  [ONBOARDING_MIGRATION_FLAGS.IS_NEW_RESET_PASSWORD]: false,
  [ONBOARDING_MIGRATION_FLAGS.IS_NEW_GENERAL]: false,
  [ONBOARDING_MIGRATION_FLAGS.IS_NEW_SETTING]: false,
  [ONBOARDING_MIGRATION_FLAGS.IS_NEW_API_INFO]: false,
  [ONBOARDING_MIGRATION_FLAGS.IS_NEW_MODULE_ACCESS_OTP]: false,
  [ONBOARDING_MIGRATION_FLAGS.IS_NEW_USER_MANAGEMENT]: false
};

/** @type {Record<string, { enable: string[], actions?: string[] }>} */
export const ENDPOINTS_ITR_WHITELIST_FLAG = {
  itr_exchange_rate_and_create: {
    enable: [],
    actions: [
      ACTION_ENDPOINTS.ITR_GET_BANKS,
      ACTION_ENDPOINTS.ITR_GET_COUNTRIES,
      ACTION_ENDPOINTS.ITR_GET_EXCHANGE_RATES,
      ACTION_ENDPOINTS.ITR_GET_INACTIVE_EXCHANGE_RATES,
      ACTION_ENDPOINTS.ITR_CREATE_QUOTATION,
      ACTION_ENDPOINTS.ITR_VALIDATE_SPECIAL_IDENTIFIER,
      ACTION_ENDPOINTS.ITR_GET_FORM_DATA,
      ACTION_ENDPOINTS.ITR_UPLOAD_FILE,
      ACTION_ENDPOINTS.ITR_SUBMIT_BUNDLE_DRAFT,
      ACTION_ENDPOINTS.ITR_UPDATE_BUNDLE_DRAFT,
      ACTION_ENDPOINTS.ITR_GET_BUNDLE_DRAFT,
      ACTION_ENDPOINTS.ITR_CHECK_PROCESS_PROGRESS,
      ACTION_ENDPOINTS.ITR_DELETE_NOTIFICATION_KEY,
      ACTION_ENDPOINTS.ITR_CHECK_EDD_PROCESS,
      ACTION_ENDPOINTS.ITR_DELETE_ALL_DRAFT_REVIEW,
      ACTION_ENDPOINTS.ITR_DELETE_DRAFT_REVIEW
    ]
  },
  itr_summary_and_payment: {
    enable: [],
    actions: [
      ACTION_ENDPOINTS.ITR_GET_BUNDLE_DRAFT_SUMMARY,
      ACTION_ENDPOINTS.ITR_REQUEST_DEPOSIT_OTP,
      ACTION_ENDPOINTS.ITR_PROCESS_BUNDLE_DRAFT,
      ACTION_ENDPOINTS.ITR_CREATE_BUNDLE_TRANSACTION,
      ACTION_ENDPOINTS.ITR_CHECK_PROCESS_PROGRESS,
      ACTION_ENDPOINTS.ITR_DELETE_NOTIFICATION_KEY,
      ACTION_ENDPOINTS.ITR_GET_BUNDLE_SUMMARY,
      ACTION_ENDPOINTS.ITR_CONFIRM_BUNDLE_TRANSACTION,
      ACTION_ENDPOINTS.ITR_CANCEL_BUNDLE_TRANSACTION,
      ACTION_ENDPOINTS.ITR_UPLOAD_CREDIT_RECEIPT
    ]
  },
  itr_history: {
    enable: [],
    actions: [
      ACTION_ENDPOINTS.ITR_GET_TRANSACTION_LIST,
      ACTION_ENDPOINTS.ITR_GET_BUNDLE_LIST,
      ACTION_ENDPOINTS.ITR_GET_BUNDLE_BY_ID,
      ACTION_ENDPOINTS.ITR_GET_TRANSACTION_BY_ID,
      ACTION_ENDPOINTS.ITR_GENERATE_RECEIPT
    ]
  },
  itr_report: {
    enable: [],
    actions: [ACTION_ENDPOINTS.ITR_GENERATE_REPORT, ACTION_ENDPOINTS.ITR_GET_REPORT]
  }
};

/**
 * @type {{ { actions: string[], enable: string[] }> }}
 */
export const ENDPOINTS_TRX_DEFAULT_FLAG = {
  dashboard_pending: {
    enable: [],
    actions: [ACTION_ENDPOINTS.GET_DASHBOARD_PENDING_TRANSACTION]
  }
};
